module.exports = __webpack_public_path__ + "img/cemig.4f029636.jpg";